import { type MCPServerInfo } from '../../types';

const GoogleFormsServer: MCPServerInfo = {
  serverId: 'GOOGLE_FORMS',
  name: 'Google Forms',
  slug: 'google-forms',
  description:
    'Google Forms MCP Server for creating forms, managing questions, and retrieving responses',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google-mcp-servers',
    commitSha: 'f86a7e2e',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleFormsServer;
